import { render, staticRenderFns } from "./adsorption-metadata-detail.vue?vue&type=template&id=2c178fce&"
import script from "./adsorption-metadata-detail.vue?vue&type=script&lang=js&"
export * from "./adsorption-metadata-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports